import "./OurStory.module.css";
import Navigation from "@/reusable_sections/Header";
import Mission from "./sections/Mission";
import EditorialTeam from "./sections/EditorialTeam";
import Values from "./sections/Values";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Navigation />
      <Mission />
      <EditorialTeam />
      <Values />
      <Footer />
    </div>;
}